import React, { useEffect } from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import { useLocation } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import MenuItemWrapper from './MenuItemWrapper';

export const NavBarWrapper = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;

  .t-hide-desktop {
    @media (min-width: 1240px) {
      display: none;
    }
  }

  .bm-burger-button button {
    display: none;
  }
  .bm-menu {
    background-color: white;
  }
  .bm-overlay,
  .bm-menu-wrap {
    top: 0;
    left: 0;
  }
  .bm-item-list {
    background-color: #ffffff;
    top: 0;
    padding-bottom: 40px;
    height: auto !important;
  }

  .bm-burger-bars {
    display: none !important;
  }

  .mobile-menu .link-option {
    margin-bottom: 20px;
    a {
      color: ${({ theme }) => theme.colors.charcoal};
      &:hover {
        text-decoration: none;
      }
    }
  }

  .bm-menu-wrap {
    width: 100% !important;
    top: 50px;
  }

  .bm-overlay {
    display: none;
  }

  .bottom-option {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0 !important;
    padding-top: 10px;
    padding-bottom: 10px;
    letter-spacing: 0.04em;
    cursor: pointer;
    & > a {
      display: flex;
      align-items: center;
    }
    .subtitle {
      font-size: 13px;
    }
    &.first {
      border-top: 1px solid #e5e5e5;
    }
    .icon {
      display: inline-block;
      width: 50px;
    }
    .content {
      display: inline-block;
      width: 178px;
    }
    .action {
      width: 35px;
      font-size: 20px;
      color: #888888;
      i {
        float: right;
      }
    }
  }

  .open-hours {
    margin-top: 5px;
    font-size: 13px;
    letter-spacing: 0.02em;
    color: #6c6c6c;
  }
`;

const GlobalStyle = createGlobalStyle`
 #extole_zone_overlay, #gorgias-chat-container, #nav-banner-mobile {
   display: ${({ isOpen }) => (isOpen ? 'none' : 'initial')};
 }

 #nav-banner-mobile {
   display: ${({ isOpen }) => (isOpen ? 'none' : 'block')};
 }

 html > body {
   overflow: ${({ isOpen }) => (isOpen ? 'hidden' : 'auto')};;
 }
`;

function MenuMobile({ toggle, closeMenu, search }) {
  const location = useLocation();

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  return (
    <NavBarWrapper className="t-hide-desktop">
      <div className="hamburger-menu" />
      <Menu isOpen={toggle} disableOverlayClick={closeMenu}>
        <GlobalStyle isOpen={toggle} />
        <div className="bg-responsive" />
        <MenuItemWrapper search={search} />
      </Menu>
    </NavBarWrapper>
  );
}

export default MenuMobile;
